import { useTranslation } from "react-i18next";
import { generatePath, useNavigate, useParams } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import FunctionTypeForm, { FunctionTypeFormInputs } from "../../components/FunctionTypeForm";
import useSettingsFunctionTypeCreateRoute_Create from "./api/useSettingsFunctionTypeCreateRoute_Create";

export default function SettingsFunctionTypeCreateRoute() {
    const { t } = useTranslation("functionType");
    const navigate = useNavigate();
    const { researchTypeId } = useParams();

    if (!researchTypeId) throw Error("no researchTypeId param in url");

    const { createFunctionType, error } = useSettingsFunctionTypeCreateRoute_Create();

    const handleSubmit = async (formData: FunctionTypeFormInputs) => {
        const createInput = {
            ...formData,
            researchTypeId,
        };

        const functionType = await createFunctionType(createInput);

        if (functionType) {
            navigate(
                generatePath(`/admin/settings/researchType/:researchTypeId/functionType/:functionTypeId`, {
                    researchTypeId,
                    functionTypeId: functionType.id,
                }),
            );
        }
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("settingsFunctionTypeCreateRoute.title")}>
                <FunctionTypeForm onSubmit={handleSubmit} error={error} />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
